import Route from '@ember/routing/route';
import { service } from '@ember/service';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { HOTEL_SETTINGS_TABS } from 'lumen/utils/spider';

@protectedRoute({ features: ['spider.settings.edit'] })
export default class HotelSettingsSpiderIndexRoute extends Route {
  @service access;
  @service router;

  redirect() {
    const availablePaths = HOTEL_SETTINGS_TABS.filter((tab) =>
      this.access.hasFeature(tab.featureFlag),
    ).map((tab) => tab.path);

    this.router.replaceWith(
      'hotel.settings.spider.spider-dashboard',
      availablePaths[0],
    );
  }
}
